import Collections from "../commons/Collections";
import { BaseService } from "./BaseService";
import AWS from "aws-sdk";

export class UtilsService extends BaseService {
  async markGiftCardAsUsed(giftcard_id, made, store) {
    try {
      return this.http(
        `app/giftcard/${giftcard_id}/made/${made}/store/${store}`,
        "put",
        {}
      );
    } catch (error) {
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async createUserAdmin(companies, name, password, role) {
    try {
      return this.http(`app/createUser`, "post", {
        companies,
        name,
        password,
        role,
      });
    } catch (error) {
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async uploadFile(name, base64) {
    try {
      AWS.config.update({
        accessKeyId: "AKIARMHLIFDQZQL5GU5H",
        secretAccessKey: "/VaOcFkcpZYTNsDxJE8NxlxyOVXHvZ1rNOO/gtrt",
        region: "us-east-1", // e.g., 'us-east-1'
      });
      let response = await this.uploadFileToS3(base64, name);
      return response.Location;
    } catch (error) {
      this.$helpers.message("Error", error.message, "error");
    }
  }
  // Method to upload a file to S3
  uploadFileToS3(base64String, fileName) {
    console.log("respuesta de name", fileName);
    console.log("respuesta de base", base64String);
    const fileExtension = fileName.split(".").pop();
    const s3 = new AWS.S3();

    // Decode the base64 string to binary data
    const binaryData = Buffer.from(base64String, "base64");
    const fileKey = "Advertising/" + fileName;
    // Create an S3 instance

    const params = {
      Bucket: "domipagobucketprod",
      Key: fileKey,
      Body: binaryData,
      ContentType: fileExtension,
    };
    return s3.upload(params).promise();
  }
  async getGiftCards(company_id) {
    try {
      return this.http(`app/giftcard?company_id=${company_id}`, "get", {});
    } catch (error) {
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async getApplicationGiftCards(company_id) {
    try {
      return this.http(`app/getApplicationGiftCards`, "get", {});
    } catch (error) {
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async updateApplicationGiftCard(giftcard_id) {
    try {
      return this.http(
        `app/updateApplicationGiftCard/${giftcard_id}`,
        "put",
        {}
      );
    } catch (error) {
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async cancelApplicationGiftCard(giftcard_id) {
    try {
      return this.http(
        `app/cancelApplicationGiftCard/${giftcard_id}`,
        "put",
        {}
      );
    } catch (error) {
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async getProvinces() {
    try {
      return this.http("app/provinces?show_all=1", "get", {});
    } catch (error) {
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async getZonesByProvince(provinceId) {
    try {
      return this.http(`app/provinces/${provinceId}/zones`, "get", {});
    } catch (error) {
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async addZone(provinceId, name, latitude, longitude) {
    try {
      return this.http(`app/provinces/${provinceId}/zones`, "post", {
        name,
        latitude,
        longitude,
      });
    } catch (error) {
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async dropZone(provinceId, zoneId) {
    try {
      return this.http(
        `app/provinces/${provinceId}/zones/${zoneId}`,
        "delete",
        {}
      );
    } catch (error) {
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async getZones(provinceId) {
    const path = `${Collections.province}/${provinceId}/${Collections.zones}`;
    const list = await this.getCollectionRef(path).get();
    return list.docs.map((d) => {
      return {
        id: d.id,
        name: d.data().name,
        provinceId: provinceId,
        selected: false,
      };
    });
  }

  async getDistanceConfig() {
    return this.http("app/distance-config", "get");
  }

  async saveDistanceConfig(data) {
    return this.http("app/distance-config", "post", data);
  }

  async getCompanyAPIInfo(companyId) {
    return this.http(`app/companies/${companyId}/api-info`, "get");
  }

  async saveCompanyAPIInfo(companyId, data) {
    return this.http(`app/companies/${companyId}/api-info`, "post", data);
  }

  async companyRunAPIProducts(companyId) {
    return this.http(`app/companies/${companyId}/run-api-products`, "post", {});
  }

  async getOnBoarding() {
    return this.http(`app/onboarding`, "get");
  }

  async getOneOnBoarding(version) {
    return this.http(`app/onboarding/${version}`, "get");
  }

  async saveOnBoarding(version, slides) {
    return this.http(`app/onboarding/${version}`, "post", { slides });
  }

  async getConvertionRateServiceFee() {
    return this.http("app/convertion-rate_service-fee", "get");
  }

  async saveConvertionRateServiceFee(data) {
    return this.http("app/convertion-rate_service-fee", "post", data);
  }
}
